import { createReducer, on } from '@ngrx/store';
import {
  loadAdvisorList,
  loadAdvisorListSuccess,
  loadAdvisorListFailure,
  clearAdvisorList,
} from './advisor.actions';

export interface AdvisorState {
  data: any[] | null;
  loading: boolean;
  error: any;
}

export const initialState: AdvisorState = {
  data: null,
  loading: false,
  error: null,
};

export const advisorReducer = createReducer(
  initialState,
  on(loadAdvisorList, (state) => ({ ...state, loading: true, error: null })),
  on(loadAdvisorListSuccess, (state, { data }) => ({ ...state, loading: false, data })),
  on(loadAdvisorListFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(clearAdvisorList, (state) => ({ ...state, data: null }))
);
